import { render, staticRenderFns } from "./nbHandleTask.vue?vue&type=template&id=ca81ba34&scoped=true"
import script from "./nbHandleTask.vue?vue&type=script&lang=js"
export * from "./nbHandleTask.vue?vue&type=script&lang=js"
import style0 from "./nbHandleTask.vue?vue&type=style&index=0&id=ca81ba34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca81ba34",
  null
  
)

export default component.exports